import React from 'react';
import PropTypes from 'prop-types';
import SellHeader from '../../../modules/react-sell-merch-header/src/index';
import {SEARCH_BAR_STYLE, SELL_HUB, SELL_HUB_ALT} from './constants';
import './index.scss';
import {LOGO_TYPES} from '@stubhub/react-logo';

export default (ChildComponent) => (
  class withHeader extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        isModalSearchActive: false
      };  
    }

    static propTypes = {
      location: PropTypes.object,
      searchBarStyle: PropTypes.oneOf([
        SEARCH_BAR_STYLE.EXPANDED, SEARCH_BAR_STYLE.MODAL
      ])
    };

    static defaultProps = {
      searchBarStyle: SEARCH_BAR_STYLE.EXPANDED
    };
    
    onModalSearchActiveChanged(isActive) {
      const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      this.setState({
        isModalSearchActive: isActive
      });
      // To Keep the Search bar in viewport when the IOS Keyboard is open. 250ms is an estimate time for IOS to open the SW keyboard
      iOS 
        ? setTimeout(() => {
          window.scrollTo(0, 0);
        }, 250)
        : '';
    }
  
    render() {
      const {isModalSearchActive} = this.state;
      const {location, searchBarStyle} = this.props;

      const isSellLanding = location.pathname === SELL_HUB || location.pathname === SELL_HUB_ALT;
      // Configure Sell landing specific styles
      const landingHeader = isSellLanding ? 'landing-header' : '';
      const headerColor = isSellLanding ? 'transparent-header' : 'white-header';
      const hideHeader = isSellLanding && isModalSearchActive ? 'hide-header' : '';
      const logoType = isSellLanding ? LOGO_TYPES.WHITE : LOGO_TYPES.MERCH;

      /*
       * TODO: We want to render a link back to sell landing on every page except for sell landing.
       * const showSellLink = !isSellLanding;
       */

      return (
        <>
          <div className={`MerchHeader_Sell mobile-${headerColor} ${landingHeader} ${hideHeader}`}>
            <SellHeader
              searchBarStyle={searchBarStyle}
              onNavMenuStateChange={() => (false)}
              noNavSecondary
              logoType={logoType}
              isSellLanding={isSellLanding}
            />
          </div>
          <ChildComponent 
            onModalSearchActiveChanged={this.onModalSearchActiveChanged.bind(this)}
            {...this.props}  
          />
        </>
      );
    }
  }
);
